<template>
  <div>
    <ejs-grid
      id="campaignsgrid"
      ref="grid"
      class="cendyn-grid sortingenabled"
      :allow-paging="true"
      :allow-filtering="true"
      :page-settings="pageSettings"
      :filter-settings="filterOptions"
      :allow-sorting="true"
      :sort-settings="initialSort"
      :data-bound="dataBound"
      :before-data-bound="beforeDataBound"
      :data-state-change="dataStateChange"
      :data-source="campaigns"
      :enable-persistence="true"
      :action-complete="actionComplete"
      clip-mode="EllipsisWithTooltip"
    >
      <e-columns>
        <e-column
          field="projectId"
          header-text="ID"
          width="120"
          type="String"
          :template="idTemplate"
          :filter="customFilter"
        />
        <e-column
          field="title"
          header-text="Name/Subject"
          :template="nameTemplate"
          :filter="customFilter"
        />
        <e-column
          field="subject"
          header-text="Subject"
          :visible="false"
        />
        <!-- <e-column field='scheduleActive' headerText='Status' width=110 :template='statusTemplate' :filter='filter'></e-column> -->
        <e-column
          field="statusCampaignTranslated"
          header-text="Status"
          width="200"
          :template="scheduleTemplate"
          :filter="statusFilter"
        />
        <e-column
          field="audienceName"
          header-text="Audience"
          :template="audienceTemplate"
          :filter="customFilter"
        />
        <e-column
          field="updateDate"
          header-text="Updated"
          :sort-comparer="sortComparer"
          :template="updatedTemplate"
          :filter="customFilter"
        />
        <e-column
          field="updatedBy"
          header-text="updatedBy"
          :visible="false"
        />
        <e-column
          field=" "
          header-text=""
          :template="actionTemplate"
          :allow-filtering="false"
          width="40"
        />
      </e-columns>
    </ejs-grid>
    <ejs-dialog
      id="dialog-schedule"
      ref="dialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="dialogTemplate"
      :overlay-click="closeDialog"
      :visible="false"
    />
    <ejs-toast
      ref="errorLoadingRef"
      title="Error"
      content="Could not load campaigns"
      :position="toastPosition"
      css-class="notification-error"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { iframeParentCommunication } from '../mixins/iframeParentCommunication'
import { mapGetters, mapState } from 'vuex'
import { Sort, Page, Filter, GridPlugin } from '@syncfusion/ej2-vue-grids'
import GridProjectId from '../components/Grid/GridProjectId'
import GridNameSubject from '../components/Grid/GridNameSubject'
import GridAudience from '../components/Grid/GridAudience'
import GridStatus from '../components/Grid/GridStatus'
import GridUpdated from '../components/Grid/GridUpdated'
import GridSchedule from '../components/Grid/GridSchedule'
import GridAction from '../components/Grid/GridAction'
import localeFormat from '../constants/dateFormat'
import { DataManager } from '@syncfusion/ej2-data'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'
import { createElement } from '@syncfusion/ej2-base'
import { TextBox } from '@syncfusion/ej2-inputs'
import moment from 'moment'
import $ from 'jquery'
MultiSelect.Inject(CheckBoxSelection)
Vue.use(GridPlugin)

const dialogTemplate = Vue.component('DialogTemplate', {
  data () {
    return {
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeDialog()
    },
    editCampaign () {
      this.$parent.$parent.editCampaign()
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" >
        <h2>Confirm</h2></br>
         <p>This project has already been scheduled.<br />
          Saving any changes to the Audience or Template will delete the existing schedule.</p>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="editCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})

export default {
  mixins: [iframeParentCommunication],
  provide: {
    grid: [Filter, Sort, Page]
  },
  props: {
    campaignType: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      data: {},
      toastPosition: { X: 'Center', Y: 'Top' },
      pageSettings: {
        pageCount: 5,
        pageSize: 10,
        pageSizes: ['10', '25', '50', '100']
      },
      filterOptions: {
        type: 'Menu',
        mode: 'OnEnter',
        operators: {
          stringOperator: [
            { value: 'startsWith', text: 'Starts With' },
            { value: 'endsWith', text: 'Ends With' },
            { value: 'contains', text: 'Contains' },
            { value: 'equal', text: 'Equal' }
          ]
        }
      },
      gridData: new DataManager(),
      customAttributes: { class: 'filtered' },
      statusFilter: {
        ui: {
          create: args => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            if (args.target.parentElement.children) {
              args.target.parentElement.children[0].style.display = 'none'
              args.target.parentElement.children[1].style.paddingTop = '0px'
            }
            this.dropInstance = new MultiSelect({
              dataSource: [
                { statusCampaignTranslated: 'Approved' },
                { statusCampaignTranslated: 'Draft' },
                { statusCampaignTranslated: 'Pending' },
                { statusCampaignTranslated: 'Rejected' },
                { statusCampaignTranslated: 'Scheduled Active' },
                { statusCampaignTranslated: 'Scheduled Inactive' },
                { statusCampaignTranslated: 'Testing' }
              ],
              fields: {
                text: 'statusCampaignTranslated',
                value: 'statusCampaignTranslated'
              },
              placeholder: 'Select a value',
              popupHeight: '200px',
              mode: 'CheckBox'
            })
            this.dropInstance.value = this.dropInstance.value || []
            this.dropInstance.appendTo(flValInput)
          },
          write: args => {
            let arr = []
            if (
              args.parent.filterModule.actualPredicate
                .statusCampaignTranslated !== undefined
            ) {
              arr = args.parent.filterModule.actualPredicate.statusCampaignTranslated.map(
                element => element.value
              )
            }
            this.dropInstance.value = Array.isArray(args.filteredValue)
              ? args.filteredValue
              : arr
          },
          read: args => {
            args.fltrObj.filterSettings.columns = args.fltrObj.filterSettings.columns.filter(
              x => x.field !== args.column.field
            )
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value
            )
          }
        }
      },
      customFilter: {
        ui: {
          create: args => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            this.dropInstance = new TextBox({
              placeholder: 'Enter the value'
            })
            this.dropInstance.appendTo(flValInput)
          },
          write: args => {
            if (args.filteredValue) {
              this.dropInstance.value = args.filteredValue
            }
          },
          read: args => {
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value,
              false
            )
          }
        }
      },
      filterFlag: false,
      initialSort: {
        columns: [{ field: 'projectId', direction: 'Descending' }]
      },
      target: '#app',
      height: '250px',
      width: '400px',
      dateTimeFormat: 'M/D/YYYY hh:mm A',
      idTemplate () {
        return {
          template: {
            extends: GridProjectId
          }
        }
      },
      nameTemplate () {
        return {
          template: {
            extends: GridNameSubject
          }
        }
      },
      audienceTemplate () {
        return {
          template: {
            extends: GridAudience
          }
        }
      },
      statusTemplate () {
        return {
          template: {
            extends: GridStatus
          }
        }
      },
      scheduleTemplate () {
        return {
          template: {
            extends: GridSchedule
          }
        }
      },
      updatedTemplate () {
        return {
          template: {
            extends: GridUpdated
          }
        }
      },
      actionTemplate () {
        return {
          template: {
            extends: GridAction
          }
        }
      },
      dialogTemplate () {
        return {
          template: dialogTemplate
        }
      },
      filters: [],
      rowsBound: false
    }
  },
  computed: {
    ...mapState({
      isPrimary: state => state.manageCampaigns.isPrimary,
      isTransactional: state => state.manageCampaigns.isTransactional,
      campaigns: state => state.manageCampaigns.campaigns,
      locale: state => state.manageCampaigns.locale,
      priorFiltersData: state => state.manageCampaigns.filtersData,
      b2bCampaignType: state => state.manageCampaigns.b2bCampaignType
    }),
    ...mapGetters(['getGridSelectedCampaign', 'getFiltersData'])
  },
  watch: {
    isPrimary (val) {
      if (val === true) {
        this.$refs.grid.showColumns(['Schedule', 'Audience'])
      } else {
        this.$refs.grid.hideColumns(['Schedule', 'Audience'])
      }
      this.loadCampaigns()
    },
    isTransactional (val) {
      this.loadCampaigns()
    },
    locale () {
      this.dateTimeFormat =
          localeFormat.dateFormat(this.locale) +
          ' ' +
          localeFormat.timeFormat(this.locale)
    }
  },
  created () {
    window.localStorage.removeItem('gridcampaignsgrid')
    window.localStorage.removeItem('gridcampaignsMessagingGrid')
  },
  async mounted () {
    this.showHideAudienceFilter()
    const clearedFilterData = {
      action: {
        currentPage: 1
      },
      take: 10
    }
    this.$store.commit('SET_FILTERS_DATA', clearedFilterData)
    const parentCompanyId = this.$route.query.clientId
    const companyId = this.$route.query.companyId
    const userEmail = this.$route.query.userEmail
      ? atob(this.$route.query.userEmail)
      : null

    if (userEmail) {
      this.$store.dispatch('setParentCompanySetting', {
        settings: 'Campaign Journey',
        email: userEmail
      })
      this.$store.dispatch('setCompanySetting', {
        settings: 'TransactionalMailingInTestMode',
        email: userEmail
      })
      this.$store.dispatch('setCompanySetting', {
        settings: 'HasEmailContentApproval',
        email: userEmail
      })
      await this.$store.commit('SET_USER_EMAIL', userEmail)
    }
    if (parentCompanyId && companyId) {
      if (this.getCurrentCompanyId !== companyId || !this.campaigns.length) {
        this.loadCampaigns()
        this.$store.commit('SET_CLIENTID', parentCompanyId)
        this.$store.commit('SET_COMPANYID', companyId)
      }
    }
    this.colorFilteredColumns()
  },
  methods: {
    showHideAudienceFilter () {
      if (this.isPrimary === true) {
        this.$refs.grid.showColumns(['Schedule', 'Audience'])
      } else {
        this.$refs.grid.hideColumns(['Schedule', 'Audience'])
      }
      this.loadCampaigns()
    },
    loadCampaigns () {
      const state = {
        action: {
          currentPage: 1
        },
        isPrimary: this.isPrimary,
        isTransactional: this.isTransactional,
        type: this.campaignType,
        skip: 0,
        take: 10
      }
      this.dataStateChange(state)
    },
    dataStateChange (dataState) {
      const priorFilters = this.getFiltersData
      dataState = {
        ...dataState,
        isPrimary: this.isPrimary,
        isTransactional: this.isTransactional,
        type: this.campaignType
      }

      if (dataState.action && dataState.action.action !== 'clearFilter' && priorFilters) {
        if (priorFilters.sorted && !dataState.sorted) {
          dataState.sorted = priorFilters.sorted
        }
        if (priorFilters.where && !dataState.where) {
          dataState.where = priorFilters.where
        }
      }

      this.$store.commit('SET_FILTERS_DATA', dataState)

      if (
        dataState.action.requestType !== 'stringfilterrequest' &&
          dataState.action.requestType !== 'refresh'
      ) {
        this.$store.dispatch('setCampaignsCountsByState', {
          companyId: this.$route.query.companyId,
          isTransactional: this.isTransactional,
          isPrimary: this.isPrimary,
          userEmail: atob(this.$route.query.userEmail),
          sales: this.b2bCampaignType === 'Sales'
        })
        this.$store.dispatch('setCampaignsByPage', {
          companyId: this.$route.query.companyId,
          isPrimary: this.isPrimary,
          userEmail: atob(this.$route.query.userEmail),
          dataState
        }).then(response => {
          console.log('setCampaignsByPage response: ', response)
        }, error => {
          console.log(error)
          console.log('error loading campaigns')
          this.$refs.errorLoadingRef.show()
        })
      }
    },
    dataBound (obj) {
      this.$refs.grid.autoFitColumns(['projectId', 'status', 'scheduleActive'])
      $('.e-emptyrow').find('td').text('')
      if (this.campaigns && this.campaigns.count === 0 && this.rowsBound === true) {
        $('.e-emptyrow').find('td').text('No records to display')
      }
    },
    beforeDataBound (obj) {
      this.rowsBound = obj && obj.actionArgs && (obj.actionArgs.requestType === 'refresh' || obj.actionArgs.requestType === 'filtering')
    },
    colorFilteredColumns () {
      this.filters = this.$refs.grid.ej2Instances.filterSettings.columns
      if (this.filters) {
        const that = this
        this.$refs.grid.ej2Instances.columns = this.$refs.grid.ej2Instances.columns.map(
          column => {
            if (that.filters.find(filter => filter.field === column.field)) {
              column.customAttributes = { class: 'filtered' }
            } else if (column.customAttributes) {
              delete column.customAttributes
            }
            return column
          }
        )
      }
    },
    sortComparer (reference, comparer) {
      const dateTimeFormat = this.dateTimeFormat || 'M/D/YYYY hh:mm A'
      const a = moment(reference, dateTimeFormat)
      const b = moment(comparer, dateTimeFormat)
      return a.valueOf() - b.valueOf()
    },
    actionComplete: function (args) {
      if (
        args.action === 'clearFilter' ||
          args.action === 'clear-filter' ||
          args.action === 'filter'
      ) {
        this.colorFilteredColumns()
      }
    },
    openDialog () {
      this.$refs.dialogTemplate.show()
    },
    closeDialog () {
      this.$refs.dialogTemplate.hide()
    },
    editCampaign () {
      const uri =
          '/Project.mvc/Project/EditSchedule?projectId=' +
          this.getGridSelectedCampaign.projectId +
          '#template'
      const data = { action: 'eIn_redirect', value: uri }
      this.SendMessageToParent(data)
      this.$refs.dialogTemplate.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-calendars/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap4.css";
  @import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap4.css";
</style>
